import { createStore } from 'vuex'
import axios from 'axios';

import createPersistedState from 'vuex-persistedstate'
import SecureLS from  'secure-ls'
var ls = new SecureLS({isCompression: false})

const getDefaultState = () => {
  return {
    currentUser: "",
    currentToken: "",
    currentGuid: "",
    books: [],
    addtlBooks: {},
    selectedBook: "",
    selectedBookModDate: "",
    selectedBookDesc: "",
    selectedPage: "",
    activePages: {},
    activeTileContent: null,
    vuexLoaderTrigger: true,
    tilesUpdate: [],
    tilesNew: [],
    tilesOpenClear: [],
    tilesCompleteClear: [],
    tiles: [],
    botleyConvo: [],
    webOnly: false,
    ubertoken: "",
    cloudstaffer: false,
    active_books: [],
    addbookmodal: false,
    bookAndDesc: [],
    newLoad: false,
    tileViewDisplay: "Progressive",
    theme: "",
    loginMode: "NONE",
    myAccountModal: false,
    myCorporateEmail: "",
    myPersonalEmail: "",
    emailEntryModal: false,
    emailChangeTypeModal: false,
    emailEntryType: "",
    tempEmailEntryType: "",
    emailOTPsent: false,
    emailEntrySent: "",
    favoriteTiles: [],
  }
}

export default createStore ({
  strict: false,
  state: getDefaultState(),
  plugins: [ 
    createPersistedState({
        paths: [
                'currentUser',
                'currentToken',
                'currentGuid',
                'books',
                'addtlBooks',
                'selectedBook',
                'activePages',
                'selectedPage',
                'selectedBookDesc',
                'selectedBookModDate',
                'activeTileContent',
                'tilesUpdate',
                'tilesNew',
                'tilesOpenClear',
                'tilesCompleteClear',
                'tiles',
                'botleyConvo',
                'webOnly',
                'ubertoken',
                'cloudstaffer',
                'active_books',
                'addbookmodal',
                'bookAndDesc',
                'newLoad',
                'tileViewDisplay',
                'theme',
                'loginMode',
                'myAccountModal',
                'emailEntryModal',
                'emailChangeTypeModal',
                'emailEntryType',
                'tempEmailEntryType',
                'myCorporateEmail',
                'myPersonalEmail',
                'emailOTPsent',
                'emailEntrySent',
                'favoriteTiles'
        ],
        storage: {
          getItem: (key) => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: (key) => ls.remove(key)
        },
        
    })
  ],

  getters: {
    authenticated (state) {
      if (
          state.currentToken != "" &&
          state.currentUser != "" &&
          (state.theme != "" || state.theme != undefined)
        ) {
          return true
        }
      return false
    },
    theme (state) {
      return state.theme;
    },
    auth_token (state) {
      return state.currentToken;
    },
    ubertoken (state) {
      return state.ubertoken;
    },
    auth_guid (state) {
      return state.currentGuid;
    },
    auth_user (state) {
      return state.currentUser;
    },
    auth_username (state) {
      var str=state.currentUser;
      var nameParts = str.split("@");
      var name = nameParts.length==2 ? nameParts[0] : null;
      return name;
    },
    addbook_modal (state) {
      return state.addbookmodal;
    },
    my_account_modal (state) {
      return state.myAccountModal;
    },
    email_entry_modal (state) {
      return state.emailEntryModal;
    },
    email_change_type_modal (state) {
      return state.emailChangeTypeModal;
    },
    email_entry_type (state) {
      return state.emailEntryType;
    },
    email_otp_sent (state) {
      return state.emailOTPsent;
    },
    email_entry_sent (state) {
      return state.emailEntrySent;
    },
    temp_email_entry_type (state) {
      return state.tempEmailEntryType;
    },
    my_corporate_email (state) {
      return state.myCorporateEmail;
    },
    my_personal_email (state) {
      return state.myPersonalEmail;
    },
    book_and_desc (state) {
      return state.bookAndDesc;
    },
    is_cloudstaffer (state) {
      return state.cloudstaffer
    },
    selected_book (state) {
      return state.selectedBook;
    },
    selected_book_mod_date (state) {
      return state.selectedBookModDate;
    },
    selected_book_desc (state) {
      return state.selectedBookDesc;
    },
    selected_page (state) {
      return state.selectedPage;
    },
    active_pages (state) {
      return state.activePages;
    },
    active_tile (state) {
      return state.activeTileContent;
    },
    active_books (state) {
      return state.active_books;
    },
    books (state) {
      return state.books;
    },
    web_only (state) {
      return state.webOnly;
    },
    botley_convo (state) {
      return state.botleyConvo;
    },
    addtlBooks(state) {
      return state.addtlBooks;
    },
    vuexLoaderTrigger(state) {
      return state.vuexLoaderTrigger;
    },
    newload(state) {
      return state.newLoad;
    },
    tiles_update(state) {
      return state.tilesUpdate;
    },
    tiles_new(state){
      return state.tilesNew;
    },

    tiles_open_clear(state) {
      return state.tilesOpenClear;
    },
    tiles_complete_clear(state){
      return state.tilesCompleteClear;
    },
    tiles(state) {
      return state.tiles;
    },
    tile_view_display(state) {
      return state.tileViewDisplay;
    },
    login_mode(state) {
      return state.loginMode;
    },
    favorite_tiles(state) {
      return state.favoriteTiles;
    },
    favorite_tile_ids(state) {
      return state.favoriteTiles.map(f => f.tile_id);
    },
  },
  mutations: {
    
    SET_STATE(state, { key, value }) {
      state[key] = value;
    },
    SET_FAVORITE_TILES(state, tiles) {
      state.favoriteTiles = tiles;
    },
    ADD_FAVORITE_TILE(state, tile) {
      if (!state.favoriteTiles.some(f => f.tile_id === tile.tile_id)) {
        state.favoriteTiles = [...state.favoriteTiles, tile];
      }
    },
    REMOVE_FAVORITE_TILE(state, tileId) {
      state.favoriteTiles = state.favoriteTiles.filter(f => f.tile_id !== tileId);
    },
    
    UNSET_TILES_UPDATED_NEW(state, payload){
        if (state.tilesUpdate.includes(payload)) {
          const i = state.tilesUpdate.indexOf(payload);
          state.tilesUpdate.splice(i, 1);
        }
      
        if (state.tilesNew.includes(payload)) {
          const j = state.tilesNew.indexOf(payload);
          state.tilesNew.splice(j, 1);
        }
    },
    UNSET_TILES_OPEN_CLEAR(state, payload){
        for (var i = 0; i < state.tilesOpenClear.length; i++) {
            if (state.tilesOpenClear[i].tile_id == payload) {
                state.tilesOpenClear.splice(i, 1);
            }
        }
    },
    UNSET_TILES_COMPLETE_CLEAR(state, payload){
      for (var i = 0; i < state.tilesCompleteClear.length; i++) {
          if (state.tilesCompleteClear[i].tile_id == payload) {
              state.tilesCompleteClear.splice(i, 1);
          }
      }
    },
    RESET_BOOKANDDESC(state){
      state.bookAndDesc = [];
    },
    SET_BOOKANDDESC(state, payload){
      var exist = false;
      for (var i = 0; i < state.bookAndDesc.length; i++) {
            if (state.bookAndDesc[i].title == payload.title) {
                exist = true;
            } 
      }

      if (exist == false) {
          state.bookAndDesc.push(payload);
      }
    },
    
    SET_BOTLEY_CONVO(state, payload){
      state.botleyConvo.push(payload);
    },
    UNSET_BOTLEY_CONVO(state){
      state.botleyConvo = [];
    },
    SET_TILES_UPDATED(state, payload){
        state.tilesUpdate.push(payload);
    },
    SET_TILES_NEW(state, payload){
      state.tilesNew.push(payload);
    },
    SET_TILES_OPEN_CLEAR(state, payload){
      state.tilesOpenClear.push(payload);
    },
    SET_TILES_COMPLETE_CLEAR(state, payload){
      state.tilesCompleteClear.push(payload);
    },
    SET_CURRENT_BOOKS (state, books) {
      state.books.push (books)
    },
    RESET_CURRENT_BOOKS (state) {
      state.books = [];
    },

    REMOVE_BOOK (state, book) {
      var index = state.books.indexOf(book);
      if (index > -1) { // only splice array when item is found
        state.books.splice(index, 1); // 2nd parameter means remove one item only
      }
    },

    SET_TILES (state, tiles) {
      state.tiles.push (tiles)
    },

    UNSET_TILES (state) {
      state.tiles = []
    },

    ACTIVE_BOOKS (state, payload) {
      if (!state.active_books.includes(payload)) {
        state.active_books.push(payload);
      }
    },

    UNSET_ACTIVE_BOOKS (state, payload) {
      var index = state.active_books.indexOf(payload);
      if (index > -1) { // only splice array when item is found
        state.active_books.splice(index, 1); // 2nd parameter means remove one item only
      }
    },

    UNSET_SELECTED_BOOK (state) {
      state.selectedBook = ""
    },

    UNSET_SELECTED_PAGE (state) {
      state.selectedPage = ""
    },

    SET_ACTIVE_TILE (state, payload) {
      state.activeTileContent = payload.tilecontent

      if (state.tilesUpdate.includes(payload.tile_id)) {
        const i = state.tilesUpdate.indexOf(payload.tile_id);
        state.tilesUpdate.splice(i, 1);
      }
    
      if (state.tilesNew.includes(payload.tile_id)) {
        const j = state.tilesNew.indexOf(payload.tile_id);
        state.tilesNew.splice(j, 1);
      }

      for (var i = 0; i < state.tilesOpenClear.length; i++) {
        if (state.tilesOpenClear[i].tile_id == payload.tile_id) {
            state.tilesOpenClear.splice(i, 1);
        }
      }
    },

    UNSET_ACTIVE_TILE (state) {
      state.activeTileContent = null
    },

    ADD_BOOK (state, payload) {
      if (!state.books.includes(payload)) {
        state.books.push(payload);
      }
    },

    REMOVE_CURRENT_AUTH (state) {
      ls.removeAll();
      localStorage.removeItem('vuex');
      Object.assign(state, getDefaultState());
    },
    
    RESET_ACTIVE_BOOKS (state) {
      state.active_books = [];
    },
  },
  actions: {
    // ✅ Replaced with SET_STATE
    setloginMode({ commit }, payload) {
      commit('SET_STATE', { key: 'loginMode', value: payload });
    },
    updateTheme({ commit }, payload) {
      commit('SET_STATE', { key: 'theme', value: payload });
    },
    updateTileViewDisplay({ commit }, payload) {
      commit('SET_STATE', { key: 'tileViewDisplay', value: payload });
    },
    updateNewLoad({ commit }, payload) {
      commit('SET_STATE', { key: 'newLoad', value: payload });
    },
    addBookModal({ commit }, payload) {
      commit('SET_STATE', { key: 'addbookmodal', value: payload });
    },
    myAccountModal({ commit }, payload) {
      commit('SET_STATE', { key: 'myAccountModal', value: payload });
    },
    emailEntryModal({ commit }, payload) {
      commit('SET_STATE', { key: 'emailEntryModal', value: payload });
    },
    emailChangeTypeModal({ commit }, payload) {
      commit('SET_STATE', { key: 'emailChangeTypeModal', value: payload });
    },
    emailEntryType({ commit }, payload) {
      commit('SET_STATE', { key: 'emailEntryType', value: payload });
    },
    emailOTPSent({ commit }, payload) {
      commit('SET_STATE', { key: 'emailOTPsent', value: payload });
    },
    emailEntrySent({ commit }, payload) {
      commit('SET_STATE', { key: 'emailEntrySent', value: payload });
    },
    tempEmailEntryType({ commit }, payload) {
      commit('SET_STATE', { key: 'tempEmailEntryType', value: payload });
    },
    myPersonalEmail({ commit }, payload) {
      commit('SET_STATE', { key: 'myPersonalEmail', value: payload });
    },
    myCorporateEmail({ commit }, payload) {
      commit('SET_STATE', { key: 'myCorporateEmail', value: payload });
    },
    setCS({ commit }, payload) {
      commit('SET_STATE', { key: 'cloudstaffer', value: payload });
    },
    setLoading({ commit }, payload) {
      commit('SET_STATE', { key: 'vuexLoaderTrigger', value: payload });
    },
    setWebOnly({ commit }, payload) {
      commit('SET_STATE', { key: 'webOnly', value: payload });
    },
    setUbertoken({ commit }, payload) {
      commit('SET_STATE', { key: 'ubertoken', value: payload });
    },
    activeBook({ commit }, payload) {
      commit('SET_STATE', { key: 'selectedBook', value: payload });
    },
    activeBookDesc({ commit }, payload) {
      commit('SET_STATE', { key: 'selectedBookDesc', value: payload });
    },
    setPages({ commit }, payload) {
      commit('SET_STATE', { key: 'activePages', value: payload });
    },
    activePage({ commit }, payload) {
      commit('SET_STATE', { key: 'selectedPage', value: payload });
    },
    setSelectedBookModDate({ commit }, payload) {
      commit('SET_STATE', { key: 'selectedBookModDate', value: payload });
    },
  
    // ✅ Keep these as-is (custom logic or array handling)
    setBookAndDesc({ commit }, payload) {
      commit('SET_BOOKANDDESC', payload);
    },
    setActiveBooks({ commit }, payload) {
      commit('ACTIVE_BOOKS', payload);
    },
    unsetActiveBooks({ commit }, payload) {
      commit('UNSET_ACTIVE_BOOKS', payload);
    },
    unsetTilesUpdatedNew({ commit }, payload) {
      commit('UNSET_TILES_UPDATED_NEW', payload);
    },
    unsetTilesOpenClear({ commit }, payload) {
      commit('UNSET_TILES_OPEN_CLEAR', payload);
    },
    unsetTilesCompleteClear({ commit }, payload) {
      commit('UNSET_TILES_COMPLETE_CLEAR', payload);
    },
    setBotleyConvo({ commit }, payload) {
      commit('SET_BOTLEY_CONVO', payload);
    },
    unsetBotleyConvo({ commit }) {
      commit('UNSET_BOTLEY_CONVO');
    },
    setTilesUpdated({ commit }, payload) {
      commit('SET_TILES_UPDATED', payload);
    },
    setTilesNew({ commit }, payload) {
      commit('SET_TILES_NEW', payload);
    },
    setOpenClear({ commit }, payload) {
      commit('SET_TILES_OPEN_CLEAR', payload);
    },
    setCompleteClear({ commit }, payload) {
      commit('SET_TILES_COMPLETE_CLEAR', payload);
    },
    addBook({ commit }, payload) {
      commit('ADD_BOOK', payload);
    },
    setTiles({ commit }, payload) {
      commit('SET_TILES', payload);
    },
    unsetTiles({ commit }) {
      commit('UNSET_TILES');
    },
    unsetActiveBook({ commit }) {
      commit('UNSET_SELECTED_BOOK');
    },
    resetActiveBooks({ commit }) {
      commit('RESET_ACTIVE_BOOKS');
    },
    resetBooksAndDesc({ commit }) {
      commit('RESET_BOOKANDDESC');
    },
    unsetActivePage({ commit }) {
      commit('UNSET_SELECTED_PAGE');
    },
    activeTile({ commit }, payload) {
      commit('SET_ACTIVE_TILE', payload);
    },
    unsetActiveTile({ commit }) {
      commit('UNSET_ACTIVE_TILE');
    },
    setBooks({ commit }, payload) {
      commit('SET_CURRENT_BOOKS', payload);
    },
    resetBooks({ commit }) {
      commit('RESET_CURRENT_BOOKS');
    },
    removeBook({ commit }, payload) {
      commit('REMOVE_BOOK', payload);
    },
    logoutUser({ commit }) {
      commit('REMOVE_CURRENT_AUTH');
    },
    verify({ commit }, payload) {
      commit('SET_STATE', { key: 'currentUser', value: payload.email });
      commit('SET_STATE', { key: 'currentToken', value: payload.token });
      commit('SET_STATE', { key: 'currentGuid', value: payload.user_guid });
    },
  
    signIn({ commit }, payload) {
      const bodyFormData = new FormData();
      bodyFormData.append('code', payload.code);
      bodyFormData.append('email', payload.email);
      bodyFormData.append('device_identifier', payload.device_identifier);
      bodyFormData.append('device_type', payload.device_type);
      bodyFormData.append('fcm_token', payload.fcm_token);
  
      axios({
        method: 'post',
        url: payload.baseAPIURL + "/apiv2/confirm.json",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        if (response.data.result === "success") {
          commit('SET_STATE', { key: 'currentUser', value: payload.email });
          commit('SET_STATE', { key: 'currentToken', value: response.data.token });
          commit('SET_STATE', { key: 'currentGuid', value: response.data.user_guid });
          commit('SET_CURRENT_BOOKS', response.data.data.book_code);
        }
      })
      .catch(err => {
        console.log("ERROR VERIFY RESPONSE: ", err);
      });
    },
  },
  
  modules: {

  }
})
